<template>
  <ul>
    <li @click="$emit('selected', root)">
      <slot :node="root" />
    </li>
    <li v-if="root.children.length > 0">
      <base-tree
        v-for="(nodeObject, index) in root.children"
        :key="index"
        v-slot="{ node }"
        :root="nodeObject"
        @selected="$emit('selected', $event)"
      >
        <slot :node="node" />
      </base-tree>
    </li>
  </ul>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { Tree } from './types'

@Component({
  name: 'base-tree',
  emits: ['selected'],
})
class BaseTree extends Vue {
  @Prop()
  root: Tree
}

export default toNative(BaseTree)
</script>
